import { createRouter, createWebHistory } from 'vue-router';
import { useMainStore } from '@/stores/mainStore';

const Home = () => import('@/components/Home.vue');
const AdminPanel = () => import('@/components/AdminPanel.vue');
const Term = () => import('@/components/Term.vue');
const FAQ = () => import('@/components/FAQ.vue');
const About = () => import('@/components/About.vue');
const A2Z = () => import('@/components/A2Z.vue');


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'BJJ Dictionary',
      requiresTermsData: true
    }
  },  
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPanel,
    meta: {
      title: 'BJJ Dictionary - Admin'
    }
  },
  {
    path: '/term/:id',
    name: 'Term',
    component: Term,
    meta: {
      title: (route) => {
        const formattedId = route.params.id
          .replace(/-/g, ' ') // Replace dashes with spaces
          .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
        return `BJJ Dictionary - ${formattedId}`;
      }
    },

  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
    meta: {
      title: 'BJJ Dictionary - FAQ'
    }
  },  
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'BJJ Dictionary - About'
    }
  },     
  {
    path: '/a-z',
    name: 'A2Z',
    component: A2Z,
    meta: {
      title: 'BJJ Dictionary - A to Z',
      requiresTermsData: true
    }
  },          
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, savedPosition) {
    // Check if the route you're navigating to is the one for term.vue
    if (to.name === 'Term') {
      // Always scroll to the top when navigating to term.vue
      return { top: 0 };
    }

    // For other routes, preserve the saved scroll position
    if (savedPosition) {
      return savedPosition;
    } else {
      // Default scroll behavior for other routes
      return { top: 0 };
    }
  }  
});

router.beforeEach(async (to, from, next) => {
  const store = useMainStore();

  const title = typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title;
  document.title = title || 'Default Title';

  console.log(to.name, 'route loaded'); // Debug log

  if (to.name === 'Term') {
    console.log("route is term", to.params.id);
    if (!store.terms[to.params.id]) {
      store.fetchOneTerm(to.params.id);
    }
  }

  next();
});

export default router;

